import React, { useState } from 'react';
import { ListItem, ListItemText, Typography, Input, Box, Slider } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { previewHistoryBatch } from '../../../../store/extensions';
import TooltipHelpButton from '../../../../../../buttons/TooltipHelpButton';

const styles = () => ({
    input: {
        width: 38,
        fontSize: 14,
        fontWeight: 500
    },
    listItemText: {
        paddingRight: 14,
        marginBottom: 0,
    },
    listItemTextRange: {
        paddingRight: 80
    },
    hideArrows: {
        '&::-webkit-inner-spin-button': {
            WebkitAppearance: 'none'
        },
        '&::-webkit-outer-spin-button': {
            WebkitAppearance: 'none'
        },
    }
});

const BackdropHlsAdjustmentSlider = ({
    title,
    hideArrows,
    onValueChange,
    toolTip,
    value,
    step,
    min,
    max,
    scale,
    classes,
}) => {
    const convertRange = (value) => {
        const normalizedValue = value + 1;
        const convertedValue = normalizedValue * 50;
        return parseFloat(convertedValue.toFixed(1));
    }

    const [displayValue, setDisplayValue] = useState(convertRange(value));

    const handleSliderChange = (event, value) => {
        setDisplayValue(value.toFixed(1));
        onValueChange(convertBackRange(value));
    }

    const handleInputChange = (event) => {
        setDisplayValue(Number(event.target.value.toFixed(1)));
        onValueChange(convertBackRange(event.target.value));
    }

    const convertBackRange = (value) => {
        const normalizedValue = value / 50;
        const adjustedValue = normalizedValue - 1;
        return adjustedValue;
    }

    const onSliderChangeCommitted = () => previewHistoryBatch.end();
    const onFocus = () => previewHistoryBatch.start();
    const onBlur = () => previewHistoryBatch.end();

    return (
        <ListItem className={classes.paddingBottom}>
            <ListItemText className={`${classes.listItemText}`}>
                <Typography
                    gutterBottom
                    variant='body2'
                    style={{ fontWeight: 'inherit' }}
                >
                    {title}
                    {toolTip ? <TooltipHelpButton title={toolTip} /> : null}
                </Typography>
                <Slider
                    size='small'
                    value={displayValue}
                    onChange={handleSliderChange}
                    step={step}
                    min={min}
                    max={max}
                    valueLabelDisplay='auto'
                    scale={scale}
                    onChangeCommitted={onSliderChangeCommitted}
                    onBlur={onBlur}
                    onFocus={onFocus}
                    sx={{
                        ".MuiSlider-valueLabel": {
                            backgroundColor: "primary.main",
                        }
                    }}
                />
            </ListItemText>
            <Box>
                <Input
                    className={classes.input}
                    value={displayValue}
                    margin='dense'
                    type='number'
                    onChange={handleInputChange}
                    inputProps={{
                        step: step,
                        min: min,
                        max: max,
                        type: 'number',
                        className: hideArrows && classes.hideArrows,
                    }}
                    onFocus={onFocus}
                    onBlur={onBlur}
                />
            </Box>
        </ListItem>
    );
};

export default withStyles(BackdropHlsAdjustmentSlider, styles);